import React, { Component } from 'react';

import compose from 'recompose/compose';
import ReactDOM from "react-dom";
// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import BarLoader from "react-spinners/BarLoader";
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import html2canvas from "html2canvas";
//Components
import Availability from '../components/Availability';
import ResponseTime from '../components/ResponseTime';
import Statistics from '../components/Statistics';
import AvailabilityGauge from '../components/AvailabilityGauge';
import Measurements from '../components/Measurements';
// import Percentage from './Periodical/Percentage'
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es' 
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
moment.locale('es')

class PdfOnline extends Component {
    constructor(props) {
        super(props);
        //console.log('params', props.params.params.location.state.fromObjective)
        this.tableDowntime=React.createRef();
        this.summaryTable=React.createRef();
        this.state = {
            params:props.params,
            schedule:props.schedule,
            actualYear:moment().year(),
            ObjectiveData:this.props.params.location.state.fromObjective,
            // modalLoad:false,
            modalLoad:true,
            modalPdf:false,
            months:['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo','Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            selectMonth:moment().format("MMMM").charAt(0).toUpperCase() + moment().format("MMMM").slice(1),
            indexMonth:moment().month(),
        }
    }
    
    handlePeriodical=()=>{
        const {ObjectiveData}=this.state
        ObjectiveData.Pasos.map(l=>{
            sessionStorage.removeItem('chartResponseTimeForStep'+l.id_paso);
            sessionStorage.removeItem('chartResponseTimeForNode'+l.id_paso);
        })
        sessionStorage.removeItem('availabilityGaugeReal');
        sessionStorage.removeItem('availabilityGauge');
        sessionStorage.removeItem('ConsolidatedCategorie');
        sessionStorage.removeItem('ConsolidatedSeries');
        sessionStorage.removeItem('chartAvailabilityConsolidated');
        sessionStorage.removeItem('chartAvailabilityConsolidatedPerStep');
        sessionStorage.removeItem('chartResponseTimeGeneral');
        sessionStorage.removeItem('chartAvailabilityStep');
        sessionStorage.removeItem('chartAvailabilityGeneral');
        sessionStorage.removeItem('chartAvailabilityNode');
        sessionStorage.removeItem('chartAvailabilityNodeDetail');
        sessionStorage.removeItem('chartAbsoluteFrecuency');
        sessionStorage.removeItem('chartCumulativeFrecuency');
        sessionStorage.removeItem('AvailabilityTableDownCum');
        sessionStorage.removeItem('AvailabilityTableNoMonCum');
        sessionStorage.removeItem('AvailabilityDowntimeTablesGlobal');
        sessionStorage.removeItem('tableMedicionISP');
        sessionStorage.removeItem('tableEstadisticaEvento');

        sessionStorage.removeItem('availaGaugeRealSession');
        sessionStorage.removeItem('availaGaugeSession');    
        sessionStorage.removeItem('availabilitySession');
        sessionStorage.removeItem('availabilitySessionTotal');
        sessionStorage.removeItem('ResponseTimeSession');
        sessionStorage.removeItem('statisticsSession');
        sessionStorage.removeItem('measurementsSession');
        sessionStorage.removeItem('nameAvailaGaugeReal');
        sessionStorage.removeItem('nameAvailaGauge');
        sessionStorage.removeItem('namePeriodAvaila');
        sessionStorage.removeItem('namePeriodAvailaTotal');
        sessionStorage.removeItem('nameResponseTime');
        sessionStorage.removeItem('nameStatistics');
        sessionStorage.removeItem('namePeriodAvailaTable');
        sessionStorage.removeItem('nameMeasurements');
        sessionStorage.removeItem('nameMeasurementsEvento');
        
        this.props.handleMainPeriodical('hola')

    }

    //VERIFICACION SI CARGO UNO DE LAS SESSIONES MAS PESADAS, SI NO VUELVE A CARGAR EL COMPONENTE
    checkSession=()=>{

   
            const {ObjectiveData}=this.state
            let review = false
            ObjectiveData.Pasos.map(l=>{
                if(JSON.parse(sessionStorage.getItem("chartResponseTimeForStep"+l.id_paso))=== null){
                    // console.log("chartResponseTimeForStep")
                    review = true
                }
                if(JSON.parse(sessionStorage.getItem("chartResponseTimeForNode"+l.id_paso))=== null){
                    // console.log("chartResponseTimeForNode")
                    review = true
                }
                
            })
            if(review === true){
                this.componentDidMount()
            }else{
                if(
                    sessionStorage.getItem("availabilityGaugeReal")==="undefined"||sessionStorage.getItem("availabilityGauge")==="undefined" ||
                    sessionStorage.getItem("chartAvailabilityConsolidated")==="undefined"||sessionStorage.getItem("chartAvailabilityConsolidatedPerStep")==="undefined" ||
                    sessionStorage.getItem("chartResponseTimeGeneral")==="undefined"||sessionStorage.getItem("chartAvailabilityStep")==="undefined" ||
                    sessionStorage.getItem("chartAvailabilityGeneral")==="undefined"||sessionStorage.getItem("chartAvailabilityNode")==="undefined"||
                    sessionStorage.getItem("chartAvailabilityNodeDetail")==="undefined" || sessionStorage.getItem("chartAbsoluteFrecuency")==="undefined"||
                    sessionStorage.getItem("chartCumulativeFrecuency")==="undefined" || sessionStorage.getItem("tableMedicionISP")==="undefined"
                    
                    ){
                    this.componentDidMount()
                }else if (JSON.parse(sessionStorage.getItem("tableEstadisticaEvento")).data === null){
                    this.componentDidMount()
                }else{
                    this.chargeData()
                }
            }
    }
    componentDidMount() {
        //LLAMA A METODO QUE CHECKEA CARGA DE SESSION
        setTimeout(
            () => this.checkSession(),
            8000
        )
    }
    //CAMBIA ESTADO DE MODALES
    chargeData=()=>{
        this.setState({
            modalLoad:false,
            modalPdf:true
            // modalPdf:false
        })
    }

    prepareData=(ObjectiveData, selectMonth,actualYear)=>{
       
        var dataChart = []

        // DISPONIBILIDAD UPTIME GLOBAL/ DÍA
        
        // OBTIENE NOMBRE DE DISPONIBILIDAD UPTIME GLOBAL/ DÍA
        let nameGaugeReal = sessionStorage.getItem('nameAvailaGaugeReal')

        let chartAavailabilityGaugeReal = sessionStorage.getItem('availabilityGaugeReal') 
        chartAavailabilityGaugeReal = JSON.parse(chartAavailabilityGaugeReal)
        chartAavailabilityGaugeReal.title.text="DISPONIBILIDAD UPTIME GLOBAL/ DÍA"
        chartAavailabilityGaugeReal.subtitle.text=nameGaugeReal
        chartAavailabilityGaugeReal.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAavailabilityGaugeReal = JSON.stringify(chartAavailabilityGaugeReal)
        dataChart.push(chartAavailabilityGaugeReal)

        // DISPONIBILIDAD ACTUAL / DÍA

        // OBTIENE NOMBRE DE DISPONIBILIDAD ACTUAL / DÍA
        let nameGauge = sessionStorage.getItem('nameAvailaGauge')

        let chartAavailabilityGauge = sessionStorage.getItem('availabilityGauge') 
        chartAavailabilityGauge = JSON.parse(chartAavailabilityGauge)
        chartAavailabilityGauge.title.text="DISPONIBILIDAD ACTUAL / DÍA"
        chartAavailabilityGauge.subtitle.text=nameGauge
        chartAavailabilityGauge.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAavailabilityGauge = JSON.stringify(chartAavailabilityGauge)
        dataChart.push(chartAavailabilityGauge)

        // *******************************************************************
        // ******************************************************************* 
        
        // DISPONIBILIDAD CONSOLIDADA    
        let ConsolidatedCategorie = sessionStorage.getItem('ConsolidatedCategorie') 
        ConsolidatedCategorie = JSON.parse(ConsolidatedCategorie)

        let ConsolidatedSeries = sessionStorage.getItem('ConsolidatedSeries') 
        ConsolidatedSeries = JSON.parse(ConsolidatedSeries)

        // OBTIENE NOMBRE DEL PERIODO DISPONIBILIDAD CONSOLIDADA
        let namePeriodAvai = sessionStorage.getItem('namePeriodAvaila')
            
        let chartOptionsStackedBarConsolidated = sessionStorage.getItem('chartAvailabilityConsolidated') 
        chartOptionsStackedBarConsolidated = JSON.parse(chartOptionsStackedBarConsolidated)
        chartOptionsStackedBarConsolidated.yAxis.labels.align = 'left'
        chartOptionsStackedBarConsolidated.yAxis.offset = 110
        chartOptionsStackedBarConsolidated.yAxis.labels.x = 10
        chartOptionsStackedBarConsolidated.yAxis.categories = ConsolidatedCategorie
        chartOptionsStackedBarConsolidated.series = ConsolidatedSeries
        chartOptionsStackedBarConsolidated.chart.height = 150
        chartOptionsStackedBarConsolidated.title.text="DISPONIBILIDAD CONSOLIDADA"
        chartOptionsStackedBarConsolidated.subtitle.text= namePeriodAvai
        chartOptionsStackedBarConsolidated.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartOptionsStackedBarConsolidated = JSON.stringify(chartOptionsStackedBarConsolidated)
        dataChart.push(chartOptionsStackedBarConsolidated)

        
        // DISPONIBILIDAD CONSOLIDADA POR NODO
        let chartAvailabilityConsolidated = sessionStorage.getItem('chartAvailabilityConsolidated') 
        chartAvailabilityConsolidated = JSON.parse(chartAvailabilityConsolidated)
        // let categoryNode = []
        // chartAvailabilityConsolidated.yAxis.categories.map(ele =>{
        //     if ((ele).length > 13) {
        //         ele = ele.substr(0,13) + "..." 
        //      }
        //      categoryNode.push(ele)    
        // })
        // chartAvailabilityConsolidated.yAxis.categories = categoryNode
        chartAvailabilityConsolidated.yAxis.labels.align = 'left'
        chartAvailabilityConsolidated.yAxis.offset = 110
        chartAvailabilityConsolidated.yAxis.labels.x = 10
        chartAvailabilityConsolidated.title.text="DISPONIBILIDAD CONSOLIDADA POR NODO"
        chartAvailabilityConsolidated.subtitle.text=namePeriodAvai
        chartAvailabilityConsolidated.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityConsolidated = JSON.stringify(chartAvailabilityConsolidated)
        dataChart.push(chartAvailabilityConsolidated)

        // DISPONIBILIDAD CONSOLIDADA POR PASO
        let chartAvailabilityConsolidatedPerStep = sessionStorage.getItem('chartAvailabilityConsolidatedPerStep')
        chartAvailabilityConsolidatedPerStep = JSON.parse(chartAvailabilityConsolidatedPerStep)
        chartAvailabilityConsolidatedPerStep.yAxis.labels.align = 'left'
        chartAvailabilityConsolidatedPerStep.yAxis.offset = 110
        chartAvailabilityConsolidatedPerStep.yAxis.labels.x = 10
        chartAvailabilityConsolidatedPerStep.title.text="DISPONIBILIDAD CONSOLIDADA POR PASO" 
        chartAvailabilityConsolidatedPerStep.subtitle.text=namePeriodAvai
        chartAvailabilityConsolidatedPerStep.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityConsolidatedPerStep = JSON.stringify(chartAvailabilityConsolidatedPerStep)    
        dataChart.push(chartAvailabilityConsolidatedPerStep)

        // *******************************************************************
        // *******************************************************************

        // OBTIENE NOMBRE DEL PERIODO TIEMPO DE RESPUESTA CONSOLIDADO
        let namePeriodResponseTime = sessionStorage.getItem('nameResponseTime')

        // TIEMPO DE RESPUESTA CONSOLIDADO
        let chartResponseTimeGeneral = sessionStorage.getItem('chartResponseTimeGeneral')
        chartResponseTimeGeneral = JSON.parse(chartResponseTimeGeneral)
        chartResponseTimeGeneral.title.text="TIEMPO DE RESPUESTA CONSOLIDADO"
        chartResponseTimeGeneral.subtitle.text=namePeriodResponseTime
        chartResponseTimeGeneral.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartResponseTimeGeneral.legend = {enabled: true}
        chartResponseTimeGeneral = JSON.stringify(chartResponseTimeGeneral)
        dataChart.push(chartResponseTimeGeneral)

        // TIEMPO DE RESPUESTA DETALLE POR PASO
        ObjectiveData.Pasos.map(l=>{
            let chartResponseTimeForStep = sessionStorage.getItem('chartResponseTimeForStep'+l.id_paso)
            chartResponseTimeForStep = JSON.parse(chartResponseTimeForStep)
            chartResponseTimeForStep.title.text= "TIEMPO DE RESPUESTA DETALLE POR PASO ("+l.nombre_paso +")"
            chartResponseTimeForStep.subtitle.text=namePeriodResponseTime
            chartResponseTimeForStep.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
            chartResponseTimeForStep = JSON.stringify(chartResponseTimeForStep)
            dataChart.push(chartResponseTimeForStep)
        })

        // TIEMPO DE RESPUESTA DETALLE POR MONITOR     
        ObjectiveData.Pasos.map(l=>{    
            let chartResponseTimeForNode = sessionStorage.getItem('chartResponseTimeForNode'+l.id_paso)
            chartResponseTimeForNode = JSON.parse(chartResponseTimeForNode)
            chartResponseTimeForNode.title.text= "TIEMPO DE RESPUESTA DETALLE POR MONITOR ("+l.nombre_paso +")"
            chartResponseTimeForNode.subtitle.text=namePeriodResponseTime
            chartResponseTimeForNode.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
            chartResponseTimeForNode = JSON.stringify(chartResponseTimeForNode)
            dataChart.push(chartResponseTimeForNode)
            
        })          

        // *******************************************************************
        // *******************************************************************

        // OBTIENE NOMBRE DEL PERIODO DISPONIBILIDAD TOTAL CONSOLIDADA
        let namePeriodAvaiTotal = sessionStorage.getItem('namePeriodAvailaTotal')

        // DISPONIBILIDAD TOTAL CONSOLIDADA
        let chartAvailabilityGeneral = sessionStorage.getItem('chartAvailabilityGeneral')
        chartAvailabilityGeneral = JSON.parse(chartAvailabilityGeneral)
        chartAvailabilityGeneral.title.text="DISPONIBILIDAD TOTAL CONSOLIDADA"
        chartAvailabilityGeneral.subtitle.text=namePeriodAvaiTotal
        chartAvailabilityGeneral.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityGeneral = JSON.stringify(chartAvailabilityGeneral)
        dataChart.push(chartAvailabilityGeneral)

        // DISPONIBILIDAD CONSOLIDADA POR ISP 
        let chartAvailabilityNode = sessionStorage.getItem('chartAvailabilityNode')
        chartAvailabilityNode = JSON.parse(chartAvailabilityNode)
        chartAvailabilityNode.title.text="DISPONIBILIDAD CONSOLIDADA POR ISP"
        chartAvailabilityNode.subtitle.text=namePeriodAvaiTotal
        chartAvailabilityNode.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityNode = JSON.stringify(chartAvailabilityNode)
        dataChart.push(chartAvailabilityNode)

        // DISPONIBILIDAD DETALLE POR ISP
        let chartAvailabilityNodeDetail = sessionStorage.getItem('chartAvailabilityNodeDetail')
        chartAvailabilityNodeDetail = JSON.parse(chartAvailabilityNodeDetail)
        chartAvailabilityNodeDetail.title.text="DISPONIBILIDAD DETALLE POR ISP"
        chartAvailabilityNodeDetail.subtitle.text=namePeriodAvaiTotal
        chartAvailabilityNodeDetail.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityNodeDetail = JSON.stringify(chartAvailabilityNodeDetail)
        dataChart.push(chartAvailabilityNodeDetail)

        // DISPONIBILIDAD DISTRIBUCIÓN PORCENTUAL
        let chartAvailabilityStep = sessionStorage.getItem('chartAvailabilityStep') 
        chartAvailabilityStep = JSON.parse(chartAvailabilityStep)
        chartAvailabilityStep.title.text="DISPONIBILIDAD DISTRIBUCIÓN PORCENTUAL"
        chartAvailabilityStep.subtitle.text=namePeriodAvaiTotal
        chartAvailabilityStep.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAvailabilityStep = JSON.stringify(chartAvailabilityStep)
        dataChart.push(chartAvailabilityStep)

        // *******************************************************************
        // ******************************************************************

        // OBTIENE NOMBRE DEL PERIODO DISPONIBILIDAD FRECUENCIA
        let nameFrecuency = sessionStorage.getItem('nameStatistics')

        // DISPONIBILIDAD FRECUENCIA ABSOLUTA
        let chartAbsoluteFrecuency = sessionStorage.getItem('chartAbsoluteFrecuency') 
        chartAbsoluteFrecuency = JSON.parse(chartAbsoluteFrecuency)
        chartAbsoluteFrecuency.title.text="DISPONIBILIDAD FRECUENCIA ABSOLUTA"
        chartAbsoluteFrecuency.subtitle.text=nameFrecuency
        chartAbsoluteFrecuency.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartAbsoluteFrecuency.legend = {enabled: true}
        chartAbsoluteFrecuency = JSON.stringify(chartAbsoluteFrecuency)
        dataChart.push(chartAbsoluteFrecuency)

        // DISPONIBILIDAD FRECUENCIA ACUMULADA
        let chartCumulativeFrecuency = sessionStorage.getItem('chartCumulativeFrecuency')
        chartCumulativeFrecuency = JSON.parse(chartCumulativeFrecuency)
        chartCumulativeFrecuency.title.text="DISPONIBILIDAD FRECUENCIA ACUMULADA"
        chartCumulativeFrecuency.subtitle.text=nameFrecuency
        chartCumulativeFrecuency.subtitle.style = {color: '#8C8C8F',fontWeight:'bold'}
        chartCumulativeFrecuency = JSON.stringify(chartCumulativeFrecuency)
        dataChart.push(chartCumulativeFrecuency)

        // *******************************************************************
        // ******************************************************************


        // TABLA DISPONIBILIDAD DOWNTIME GLOBAL POR PASO
        let chartAvailabilityDowntimeContTables = sessionStorage.getItem("AvailabilityDowntimeTablesGlobal")
        chartAvailabilityDowntimeContTables = JSON.parse(chartAvailabilityDowntimeContTables)     

        // TABLA PANEL DINÁMICO: CONSOLIDACIÓN DE MEDICIONES POR ISP
        let chartTableMedicionISP = sessionStorage.getItem('tableMedicionISP')
        chartTableMedicionISP = JSON.parse(chartTableMedicionISP)
        // chartTableMedicionISP.data.map(ele =>{
        //     if ((ele.monitor).length > 13) {
        //         ele.monitor = ele.monitor.substr(0,13) + "..."
        //         chartTableMedicionISP.data.monitor =  ele.monitor         
        //      }
            
        // })

        let chartTableEstadisticaEvento = sessionStorage.getItem('tableEstadisticaEvento')
        chartTableEstadisticaEvento = JSON.parse(chartTableEstadisticaEvento)
        // chartTableEstadisticaEvento.data.map(ele =>{
        //     if ((ele.paso).length > 13) {
        //         ele.paso = ele.paso.substr(0,13) + "..."
        //         chartTableEstadisticaEvento.data.paso =  ele.paso         
        //      }
            
        // })
  


        let nameObjetivo = 'Reporte_Online_'+ObjectiveData.nombre+'_Mes_'+selectMonth+'_Año_'+actualYear

        this.setState({
            modalLoad:true,
            modalPdf:false
        })

        var data ={
            "name":nameObjetivo, // Nombre del Objetivo
            "charts":dataChart, // Graficos
            "pdf":"online",
            "tables":[chartTableMedicionISP,chartTableEstadisticaEvento,chartAvailabilityDowntimeContTables]// TABLA PANEL DINÁMICO: CONSOLIDACIÓN DE MEDICIONES POR ISP        
        }         
                

        var data =JSON.stringify(data)               
        fetch(`https://api-ar.atentus.com/graficos`, {
            method: 'POST',
            body: data,
        })

        .catch(err => {
            console.log("fetch error" + err);
        })

        
        .then(res => {              
            window.open("https://api-ar.atentus.com/checkPdf/"+nameObjetivo)

            this.setState({
                modalLoad:false,
                modalPdf:true
            })
            
        })
        // })     
    } 

    sendData=()=>{
        const {ObjectiveData, selectMonth,actualYear}=this.state
        this.setState({
            modalLoad:true,
            modalPdf:false
        })
        setTimeout(
            () => this.prepareData(ObjectiveData, selectMonth,actualYear),
            500
        )
    } 

    period = (period,startDate,endDate)=>{
      
        if (period === 'hora') {
            var period = 'h'
            var namePeriod = 'Rango: última hora'
            return ([period,namePeriod])
        } else if (period === '3hora') {
            var period = '3h'
            var namePeriod = 'Rango: últimas 3 horas'
            return ([period,namePeriod])
        } else if (period === 'dia') {
            var period = 'd'
            var namePeriod = 'Rango: último día'
            return ([period,namePeriod])
        } else if (period === '3dia') {
            var period = '3d'
            var namePeriod = 'Rango: últimos 3 días'
            return ([period,namePeriod])
        } else if (period === 'semana') {
            var period = 'w'
            var namePeriod = 'Rango: última semana'
            return ([period,namePeriod])
        }else if (period === 'custom') {
            var period = "c"
            var namePeriod = 'Rango: ' + startDate.substring(0, 10) + ' a ' + endDate.substring(0, 10)
            return ([period,namePeriod])
        }

    }

    render() {
        const {params, schedule,actualYear, selectMonth, indexMonth, ObjectiveData, modalLoad, modalPdf}=this.state
        const {classes}=this.props

        let availaGaugeRealSession = sessionStorage.getItem('availaGaugeRealSession')
        availaGaugeRealSession = JSON.parse(availaGaugeRealSession)

        let availaGaugeSession = sessionStorage.getItem('availaGaugeSession')
        availaGaugeSession = JSON.parse(availaGaugeSession)

        let availabilitySession = sessionStorage.getItem('availabilitySession')
        availabilitySession = JSON.parse(availabilitySession)

        let availabilitySessionTotal = sessionStorage.getItem('availabilitySessionTotal')
        availabilitySessionTotal = JSON.parse(availabilitySessionTotal)

        let ResponseTimeSession = sessionStorage.getItem('ResponseTimeSession')
        ResponseTimeSession = JSON.parse(ResponseTimeSession)

        let statisticsSession = sessionStorage.getItem('statisticsSession')
        statisticsSession = JSON.parse(statisticsSession)

        let availabilitySessionTable = sessionStorage.getItem('availabilitySessionTable')
        availabilitySessionTable = JSON.parse(availabilitySessionTable)

        let measurementsSession = sessionStorage.getItem('measurementsSession')
        measurementsSession = JSON.parse(measurementsSession)

        if (availaGaugeRealSession) {
            var period = availaGaugeRealSession.nextPeriod
            var startDate = availaGaugeRealSession.statePeriod.startDate
            var endDate = availaGaugeRealSession.statePeriod.endDate
            var statePeriodAvailaGaugeReal = availaGaugeRealSession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodAvailaGaugeReal = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("nameAvailaGaugeReal",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: último día'
            sessionStorage.setItem("nameAvailaGaugeReal",JSON.stringify(namePeriod))
            var periodAvailaGaugeReal = 'd'
        }

        if (availaGaugeSession) {
            var period = availaGaugeSession.nextPeriod
            var startDate = availaGaugeSession.statePeriod.startDate
            var endDate = availaGaugeSession.statePeriod.endDate
            var statePeriodAvailaGauge = availaGaugeSession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodAvailaGauge = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("nameAvailaGauge",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: último día'
            sessionStorage.setItem("nameAvailaGauge",JSON.stringify(namePeriod))
            var periodAvailaGauge = 'd'
        }

        if (availabilitySession) {
            var period = availabilitySession.nextPeriod
            var startDate = availabilitySession.statePeriod.startDate
            var endDate = availabilitySession.statePeriod.endDate
            var statePeriodAvailability = availabilitySession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodAvailability = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("namePeriodAvaila",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: último día'
            sessionStorage.setItem("namePeriodAvaila",JSON.stringify(namePeriod))
            var periodAvailability = 'd'
        }

        if (availabilitySessionTotal) {
            var period = availabilitySessionTotal.nextPeriod
            var startDate = availabilitySessionTotal.statePeriod.startDate
            var endDate = availabilitySessionTotal.statePeriod.endDate
            var statePeriodAvailaTotal = availabilitySessionTotal.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodAvaiTotal = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("namePeriodAvailaTotal",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: última hora'
            sessionStorage.setItem("namePeriodAvailaTotal",JSON.stringify(namePeriod))
            var periodAvaiTotal = 'h'
        }

        if (ResponseTimeSession) {
            var period = ResponseTimeSession.nextPeriod
            var startDate = ResponseTimeSession.statePeriod.startDate
            var endDate = ResponseTimeSession.statePeriod.endDate
            var statePeriodResponseTime = ResponseTimeSession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodResponseTime = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("nameResponseTime",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: último día'
            sessionStorage.setItem("nameResponseTime",JSON.stringify(namePeriod))
            var periodResponseTime = 'd'
        }

        if (statisticsSession) {
            var period = statisticsSession.nextPeriod
            var startDate = statisticsSession.statePeriod.startDate
            var endDate = statisticsSession.statePeriod.endDate
            var statePeriodStatistics = statisticsSession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodstatistics = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("nameStatistics",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: última hora'
            sessionStorage.setItem("nameStatistics",JSON.stringify(namePeriod))
            var periodstatistics = 'h'
        }   

        if (availabilitySessionTable) {
            var period = availabilitySessionTable.nextPeriod
            var startDate = availabilitySessionTable.statePeriod.startDate
            var endDate = availabilitySessionTable.statePeriod.endDate
            var statePeriodAvailaTable = availabilitySessionTable.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodAvaiTable = periodAva[0] 
            var namePeriod = periodAva[1] 
            sessionStorage.setItem("namePeriodAvailaTable",JSON.stringify(namePeriod))
        }else{
            var namePeriod = 'Rango: última hora'
            sessionStorage.setItem("namePeriodAvailaTable",JSON.stringify(namePeriod))
            var periodAvaiTable = 'd'
        }  
        
        if (measurementsSession) {
            var period = measurementsSession.nextPeriod
            var startDate = measurementsSession.statePeriod.startDate
            var endDate = measurementsSession.statePeriod.endDate
            var statePeriodMeasurements = measurementsSession.statePeriod
            const periodAva =  this.period(period,startDate,endDate)
            var periodmeasurements = periodAva[0] 
            var namePeriodEvent = periodAva[1] 
            sessionStorage.setItem("nameMeasurementsEvento",JSON.stringify(namePeriodEvent))
        }else{
            var namePeriod = 'Rango: último día'
            var namePeriodEvent = 'Rango: último día'
            sessionStorage.setItem("nameMeasurementsEvento",JSON.stringify(namePeriodEvent))
            var periodmeasurements = 'd'
        }  


        return (
            <Grid
                container
                spacing={1}
            >
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={modalLoad}
                    //onClose={this.setCloseModal}
                    style={{
                        //maxHeight:'40vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 100,
                    }}               
                >
                    <Fade in={modalLoad}>
                        <BarLoader sizeUnit={"px"}  width={350} height={7} color="#00acc1" loading={true}/>
                    </Fade>
                </Modal>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={modalPdf}
                    //onClose={this.setCloseModal}
                    style={{
                        //maxHeight:'40vh',
                        
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    
                    disableAutoFocus={true}
                    disableEnforceFocus={true}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 100,
                    }}               
                >
                    <Fade in={modalPdf}>
                        {/* <Grid container spacing={2} style = {{backgroundColor : "#37312f" ,width: "30%"}}> */}
                        <Grid container spacing={2} style = {{backgroundColor : "white" ,width: "25%"}}>
                        {/* <Grid container spacing={4} style = {{backgroundColor : "transparent" }}> */}
                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <Button     
                                    // style ={{border:"orange 2px solid"}}
                                    className={classes.buttonPeriodical} 
                                    size="large"
                                    startIcon={<ArrowBackIosIcon />} 
                                    onClick={this.handlePeriodical.bind()}> 
                                    Volver a Online
                                </Button>
                                
                            </Grid>

                            <Grid
                                item
                                sm={12}
                                md={12}
                                xl={12}
                                style={{textAlign:"center"}}      
                            >
                                <Button 
                                    style ={{border:"orange 2px solid"}} 
                                    className={classes.buttonPeriodical}
                                    startIcon={<CloudDownloadIcon />}
                                    onClick={this.sendData}
                                    size="large"
                                    >
                                    <Typography variant="button">Descargar Pdf</Typography>
                                </Button>

                            </Grid>
                        </Grid>
                    </Fade>      
                                
                </Modal>    

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                >
                    <AvailabilityGauge title="Disponibilidad Uptime Global /" period={periodAvailaGaugeReal} id="gauged-h"
                    typePeriod={1} real={true} size="25%" textSize="25" dataLabelsY="-35" statePeriodAvailaGaugeReal ={statePeriodAvailaGaugeReal} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}
                >
                    <AvailabilityGauge title="Disponibilidad Actual /" period={periodAvailaGauge} id="gauged-h" 
                    typePeriod={1} online={true} size="25%" textSize="25" dataLabelsY="-35" statePeriodAvailaGauge={statePeriodAvailaGauge} />
                </Grid>    
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                    
                >
                <Availability 
                // DISPONIBILIDAD CONSOLIDADA
                    params={this.props} schedule={schedule} online={true} year={actualYear} AvailabilityCon={'AvailabilityCon'}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvailability}
                    typePeriod={1} typeGraph={7} statePeriodAvailability ={statePeriodAvailability}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                   
                >
                <Availability 
                // DISPONIBILIDAD CONSOLIDADA POR PASO
                    params={this.props} schedule={schedule} online={true} year={actualYear} AvailabilityCon={'AvailabilityCon'}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvailability}
                    typePeriod={1} typeGraph={8} statePeriodAvailability ={statePeriodAvailability}/>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >   
                {/* Tiempo de Respuesta Consolidado */}
                    <ResponseTime params={this.props} schedule={schedule} online={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period={periodResponseTime}
                    typePeriod={1} typeGraph={0} statePeriodResponseTime ={statePeriodResponseTime}/>
                </Grid>

                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Tiempo de Respuesta Detalle por Paso */}
                   <ResponseTime params={this.props} schedule={schedule} online={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period={periodResponseTime} pdf={true}
                        typePeriod={1} typeGraph={1} step={ele} statePeriodResponseTime ={statePeriodResponseTime}/>
                    </Grid>
                ))}
                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    {/* Tiempo de Respuesta Detalle por Monitor  */}
                   <ResponseTime params={this.props} schedule={schedule} online={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Tiempo de Respuesta" period={periodResponseTime} pdf={true}
                        typePeriod={1} typeGraph={2} step={ele} statePeriodResponseTime ={statePeriodResponseTime}/>
                    </Grid>
                ))}
                {/* Disponibilidad Total Consolidada */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvaiTotal}
                    typePeriod={0} typeGraph={0} statePeriodAvailaTotal ={statePeriodAvailaTotal} AvailabilityTotal={'AvailabilityTotal'}/>
                </Grid>

                {/* Disponibilidad Uptime Real */}
                {/* <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="h"
                    typePeriod={0} typeGraph={1}/>
                </Grid> */}

                {/* Disponibilidad Consolidada Por ISP */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvaiTotal}
                    typePeriod={0} typeGraph={2} statePeriodAvailaTotal ={statePeriodAvailaTotal} AvailabilityTotal={'AvailabilityTotal'}/>
                </Grid>

                {/* Disponibilidad Detalle Por ISP */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                  
                >
                    
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvaiTotal}
                    typePeriod={0} typeGraph={5} statePeriodAvailaTotal ={statePeriodAvailaTotal} AvailabilityTotal={'AvailabilityTotal'}/>
                </Grid>   

                {/* Disponibilidad Distribución Porcentual */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                               
                >
                    
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period='h'
                    typePeriod={0} typeGraph={4} />
                </Grid>

                {/* TABLA Disponibilidad Resumen */}
                {/* <Grid
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    xl={7}
                    ref={this.summaryTable}                              
                >
                <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                    typePeriod={3} typeGraph={9}/>
                </Grid>  */}
                
               
                 {/*Disponibilidad Downtime Global Por Paso */}
                {/*                  
                {ObjectiveData.Pasos.map(ele=>(
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        xl={12}                                  
                    >
                       
                    <Availability params={this.props} schedule={schedule} periodical={true} year={actualYear}
                        month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period="c"
                        typePeriod={3} typeGraph={6} steps={ObjectiveData.Pasos} indexStep={ele.id_paso} isStep={true}/>
                    </Grid>   
                ))}
                 */}

                 {/* Disponibilidad Frecuencia Absoluta */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                
                >
                   
                    <Statistics params={this.props} schedule={schedule} online={true}
                    year={actualYear} month={selectMonth} indexMonth={indexMonth} title="Disponibilidad"
                    period={periodstatistics} id="availability-h" typePeriod={0} typeGraph={0} statePeriodStatistics ={statePeriodStatistics} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}                                      
                >
                    {/* Disponibilidad Frecuencia Acumulada */}
                    <Statistics params={this.props} schedule={schedule} online={true}
                    year={actualYear} month={selectMonth} indexMonth={indexMonth} statePeriodStatistics ={statePeriodStatistics}
                    title="Disponibilidad" period={periodstatistics} id="availability-h" typePeriod={0} typeGraph={1}/>
                </Grid>

                 {/* TABLA  DOWNTIME GLOBAL*/}
                 <Grid
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    xl={7}                               
                >
                <Availability params={this.props} schedule={schedule}  year={actualYear}  online={true}
                    month={selectMonth} indexMonth={indexMonth} title="Disponibilidad" period={periodAvaiTable}
                    typePeriod={1} typeGraph={10} AvailabilityTable ='AvailabilityTable' statePeriodAvailaTable ={statePeriodAvailaTable} />
                </Grid>

                  {/* TABLA Panel Dinámico: Consolidación de Mediciones por ISP */}
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    xl={12}   
                    //style={{border: "1px solid rgb(204, 204, 204)"}} 
                                            
                >
                    <Measurements params={this.props} title="Tiempo de Respuesta y Disponibilidad por Isp" 
                    period={periodmeasurements} id="availability-h" typePeriod={1} typeGraph={6} online={true}
                     size="90%" textSize="25" dataLabelsY="-35" statePeriodMeasurements ={statePeriodMeasurements}/>
                </Grid>

            </Grid>
            
        );
    }
}

export default compose(withWidth(), withStyles(styles))(PdfOnline);
